module.exports = __webpack_public_path__ + "static/media/battery-state-error.2cfe1871.png";